import axios from 'axios';

const cartDelivery = () => {
	let onDeliveryChange = () => {
		$(document).on("change", ".js-delivery-selector", function (e) {
			let element = e.target;
			let ajax = axios('get_payments.html?IDK=' + element.value);
			
			ajax.then(function (response) {
				let data = response.data;
				$(document).find("#js-payment-wrapper").html(data);
				
				updateCosts(element.dataset.value, element.dataset.currency);
			});
		});
	};
	
	let onDeliveryCountryChange = () => {
		$(document).on("change", "#CountryID", function (e) {
			let element = e.target;
			let ajax = axios('get_shipping.html?cid=' + element.value);
			
			ajax.then(function (response) {
				let data = response.data;
				$("#payment-and-delivery").html(data.html);
				if (data.status == 'success') {
					$('.js-delivery-selector:checked').trigger('change');
				}
			});
		});
	}
	
	let onPaymentChange = () => {
		/*$(document).on("change", ".cart-shipment__JS_payment", function(e){
			let element = e.target;
			let form = element.closest("form");

			form.submit();
		});*/
	};
	
	let updateCosts = (deliveryCost, currency) => {
		let totalCost = document.getElementById('js-total-cost').value;
		let deliveryCostElement = document.getElementById('js-delivery-cost');
		let totalCostElement = document.getElementById('js-cart-total');
		
		deliveryCostElement.innerText = parseFloat(deliveryCost).toFixed(2) + " " + currency;
		totalCostElement.innerText = (parseFloat(totalCost) + parseFloat(deliveryCost)).toFixed(2) + " " + currency;
	};
	
	onDeliveryChange();
	onDeliveryCountryChange();
}

export default cartDelivery();


// WEBPACK FOOTER //
// ./components/Cart/delivery/delivery.js